import { ApiConfig } from "./apiConfig";

export const get_status = async () => {
    try {
      const response = await ApiConfig.post(`getRole_status`);
      return response.data;
    } catch (error) {
      throw error;
    }
};